/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_Proof_ReplaceInputs */

const vi_tea_purchase_payment_proof_replace = /** @type {(inputs: Tea_Purchase_Payment_Proof_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi ảnh khác`)
};

/**

* @param {Tea_Purchase_Payment_Proof_ReplaceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_proof_replace = /** @type {((inputs?: Tea_Purchase_Payment_Proof_ReplaceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_Proof_ReplaceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_proof_replace(inputs)
});